import axiosInstance from "../../../../axiosInstance";
import { error, success, info, warning } from "../../../../store/notification/actions";

export async function submitEmployee(data) {
  if (data != null) {
    info("Adding new Employee...");
    return await axiosInstance
      .post("/employee/addEmployee", {
        storeId: data.storeid,
        firstName: data.firstname,
        middleName: data.middlename,
        lastName: data.lastname,
        dob: data.dob ? data.dob : "",
        street1: data.street1,
        street2: data.street2,
        countryId: data.country ? data.country.id.toString() : "",
        stateId: data.state ? data.state.id.toString() : "",
        cityId: data.city ? data.city.id.toString() : "",
        emergencyContactNo:
          data.emergencycontactno === "" ? "0" : data.emergencycontactno,
        mobileNo: data.mobileno,
        email: data.email,
        idProof: data.idproof,
        joinDate: data.joindate ? data.joindate : null,
        lastWorkingDate: data.lastworkingdate ? data.lastworkingdate : null,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Employee Created successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

export const getEmployees = (storeId) => {
  info("Loading Employees...");
  return axiosInstance
    .get(`employee/getEmployees/${storeId}`)
    .then((res) => {
      if (res.data.status === "success") {
        if (res.data.data.length > 0) {
          success("Loaded Successfully!!!");
        } else {
          warning("No records found !!!");
        }
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export const editEmployee = (data) => {
  info("Editing Employee...");
  return axiosInstance
    .post("/employee/editEmployee", {
      employeeId: data.employeeid,
      storeId: data.storeid,
      firstName: data.firstname,
      middleName: data.middlename,
      lastName: data.lastname,
      dob: data.dob ? data.dob : "",
      street1: data.street1,
      street2: data.street2,
      countryId: data.country ? data.country.id.toString() : "",
      stateId: data.state ? data.state.id.toString() : "",
      cityId: data.city ? data.city.id.toString() : "",
      emergencyContactNo:
        data.emergencycontactno === "" ? "0" : data.emergencycontactno,
      mobileNo: data.mobileno,
      email: data.email,
      idProof: data.idproof,
      joinDate: data.joindate ? data.joindate : null,
      lastWorkingDate: data.lastworkingdate ? data.lastworkingdate : null,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("Employee Edited successfully");
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export const deleteEmployee = (employee) => {
  info("Deleting Employee...");
  return axiosInstance
    .post("/employee/deleteEmployee", employee)
    .then((res) => {
      if (res.data.status === "success") {
        success("Employee Deleted successfully");
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};
